































import { Component, Vue } from 'vue-property-decorator';
import { BusinessCentralOrders } from '@/models/BusinessCentralOrders';
import { websiteText } from '@/mixins/websiteTexts';

@Component
export default class BusinessCentralOrdersWidget extends Vue {
    private orders: BusinessCentralOrders | null = null;
    isLoading: boolean = false;
    hasError: boolean = false;
    myOrdersUrl: string = "/everyday/genvagar/mina-ordrar";
    myOrdersTitle: string = "/everyday/genvagar/mina-ordrar";

    constructor() {
        super();
        this.myOrdersUrl = this.$attrs['data-my-orders-url'];
        this.myOrdersTitle = this.$attrs['data-my-orders-title'];
    }

    mounted() {
        this.getOrders();
    }

    getOrders() {
        this.isLoading = true;
        this.hasError = false;
        const path = `/api/everyday/businesscentral/orders`;
        const requestContext = (window as any).__litium.requestContext;

        fetch(path, {
            method: 'get',
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        this.orders = data;
                        this.isLoading = false;
                    });
                } else {
                    console.error('Failed to load');
                    this.hasError = true;
                    this.isLoading = false;
                }
            })
            .catch(error => {
                console.error('Failed to laod', error);
                this.hasError = true;
                this.isLoading = false;
            });
    }
}
